import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["className"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { AlignLeftOutlined, CheckSquareOutlined, EditOutlined, FileTextOutlined, FormOutlined, LinkOutlined, PlusOutlined, AudioOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { message, Popover } from 'antd';
import { styleVariables } from '@lib/common';
import { QuestionType } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledPopover = styled(function (_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Popover, _objectSpread(_objectSpread({}, props), {}, {
    overlayClassName: className
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-popover-arrow {\n    display: none;\n  }\n\n  .ant-popover-inner {\n    border: 1px solid #b8cbee;\n    border-radius: 16px;\n    box-shadow:\n      0 16px 40px rgba(30, 55, 90, 0.2),\n      0 4px 12px rgba(30, 55, 90, 0.1);\n  }\n\n  .ant-popover-inner-content {\n    padding: 16px;\n  }\n"])));
var StyledPlusButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  border: 0;\n  color: white;\n  background: ", ";\n  box-shadow:\n    0 0 0 4px #eaf0ff,\n    0 4px 8px rgba(30, 55, 90, 0.12);\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: 2px solid ", ";\n    outline-offset: 5px;\n  }\n"])), function (props) {
  return props.$active ? styleVariables.colors.colorPrimaryBase : styleVariables.colors.gray7;
}, styleVariables.colors.colorPrimaryBase);
var AccessibilityBarWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  z-index: 1;\n"])));
var PlusIcon = styled(PlusOutlined)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 28px;\n"])));
var QuestionListContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 288px;\n  max-width: calc(100vw - 64px);\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n"])));
var MenuTitle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eef2f7;\n  color: #7387a7;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"])));
var GroupTitle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin: 12px 0 6px;\n  color: #7387a7;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n"])));
var StructureGroup = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  border-top: 1px solid #eef2f7;\n"])));
var MenuButton = styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 8px 4px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s;\n\n  &:hover,\n  &:focus-visible {\n    background: #f3f7ff;\n  }\n\n  &:focus-visible {\n    outline: 2px solid ", ";\n    outline-offset: -2px;\n  }\n"])), styleVariables.colors.colorPrimaryBase);
var MenuIcon = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 30px;\n  height: 30px;\n  border-radius: 7px;\n  font-size: 16px;\n  color: ", ";\n  background: ", ";\n"])), function (_ref2) {
  var $tone = _ref2.$tone;
  return {
    blue: '#2563eb',
    green: '#10b981',
    orange: '#ed8936',
    slate: '#52647e'
  }[$tone];
}, function (_ref3) {
  var $tone = _ref3.$tone;
  return {
    blue: '#eff5ff',
    green: '#ecfdf5',
    orange: '#fff4e9',
    slate: '#f1f5f9'
  }[$tone];
});
var ItemTitle = styled.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: block;\n  color: #25334b;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n"])));
var ItemDescription = styled.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: block;\n  margin-top: 2px;\n  color: #7387a7;\n  font-size: 11px;\n  line-height: 16px;\n"])));
export var AccessibilityBar = function AccessibilityBar(_ref4) {
  var onCreateSection = _ref4.onCreateSection,
      onCreateQuestion = _ref4.onCreateQuestion,
      visible = _ref4.visible,
      onTriggerVisibleChange = _ref4.onTriggerVisibleChange,
      hasUnsavedQuestionOrSectionChanges = _ref4.hasUnsavedQuestionOrSectionChanges,
      labelTranslation = _ref4.labelTranslation,
      possibleQuestionCreationTypes = _ref4.possibleQuestionCreationTypes,
      onCreateHeading = _ref4.onCreateHeading,
      _ref4$isHideCreateQue = _ref4.isHideCreateQuestionOptions,
      isHideCreateQuestionOptions = _ref4$isHideCreateQue === void 0 ? false : _ref4$isHideCreateQue;

  var renderItem = function renderItem(title, description, icon, onClick) {
    var tone = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'blue';
    var key = arguments.length > 5 ? arguments[5] : undefined;
    return /*#__PURE__*/_jsxs(MenuButton, {
      type: "button",
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(MenuIcon, {
        $tone: tone,
        "aria-hidden": "true",
        children: icon
      }), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(ItemTitle, {
          children: title
        }), /*#__PURE__*/_jsx(ItemDescription, {
          children: description
        })]
      })]
    }, key);
  };

  var renderQuestion = function renderQuestion(type) {
    switch (type) {
      case QuestionType.Essay:
        return renderItem(labelTranslation.essay, labelTranslation.essayDescription, /*#__PURE__*/_jsx(FormOutlined, {}), function () {
          return onCreateQuestion(QuestionType.Essay);
        }, 'green', type);

      case QuestionType.SingleChoice:
        return renderItem(labelTranslation.singleChoiceQuestion, labelTranslation.singleChoiceDescription, /*#__PURE__*/_jsx(CheckCircleOutlined, {}), function () {
          return onCreateQuestion(QuestionType.SingleChoice);
        }, 'blue', type);

      case QuestionType.MultipleChoice:
        return renderItem(labelTranslation.multipleChoiceQuestion, labelTranslation.multipleChoiceDescription, /*#__PURE__*/_jsx(CheckSquareOutlined, {}), function () {
          return onCreateQuestion(QuestionType.MultipleChoice);
        }, 'blue', type);

      case QuestionType.Speaking:
        return renderItem(labelTranslation.speakingQuestion || 'Speaking', labelTranslation.speakingDescription, /*#__PURE__*/_jsx(AudioOutlined, {}), function () {
          return onCreateQuestion(QuestionType.Speaking);
        }, 'orange', type);

      case QuestionType.FillInBlank:
        return renderItem(labelTranslation.fillInBlankQuestion, labelTranslation.fillInBlankDescription, /*#__PURE__*/_jsx(AlignLeftOutlined, {}), function () {
          return onCreateQuestion(QuestionType.FillInBlank);
        }, 'blue', type);

      case QuestionType.Matching:
        return renderItem(labelTranslation.matchingQuestion, labelTranslation.matchingDescription, /*#__PURE__*/_jsx(LinkOutlined, {}), function () {
          return onCreateQuestion(QuestionType.Matching);
        }, 'slate', type);

      default:
        return null;
    }
  };

  var availableTypes = possibleQuestionCreationTypes || [QuestionType.Essay, QuestionType.SingleChoice, QuestionType.MultipleChoice, QuestionType.Speaking, QuestionType.FillInBlank, QuestionType.Matching];
  var basicTypes = availableTypes.filter(function (type) {
    return QuestionType.basicQuestionTypes.includes(type);
  });
  var groupTypes = availableTypes.filter(function (type) {
    return QuestionType.groupQuestionTypes.includes(type);
  });

  var content = /*#__PURE__*/_jsxs(QuestionListContainer, {
    children: [/*#__PURE__*/_jsx(MenuTitle, {
      children: labelTranslation.addContent
    }), !isHideCreateQuestionOptions && /*#__PURE__*/_jsxs(_Fragment, {
      children: [basicTypes.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(GroupTitle, {
          children: labelTranslation.questionTypes
        }), basicTypes.map(renderQuestion)]
      }), groupTypes.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(GroupTitle, {
          children: labelTranslation.addGroupQuestions
        }), groupTypes.map(renderQuestion)]
      })]
    }), /*#__PURE__*/_jsxs(StructureGroup, {
      children: [/*#__PURE__*/_jsx(GroupTitle, {
        children: labelTranslation.formStructure
      }), !isHideCreateQuestionOptions && renderItem(labelTranslation.addHeading, labelTranslation.headingDescription, /*#__PURE__*/_jsx(EditOutlined, {}), onCreateHeading), renderItem(labelTranslation.addSection, labelTranslation.sectionDescription, /*#__PURE__*/_jsx(FileTextOutlined, {}), onCreateSection, 'slate')]
    })]
  });

  var handleBlockedCreateClick = function handleBlockedCreateClick() {
    message.warning(labelTranslation.questionChangingWarning);
  };

  return /*#__PURE__*/_jsx(AccessibilityBarWrapper, {
    children: !hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsx(StyledPopover, {
      open: visible,
      placement: "leftTop",
      content: content,
      onOpenChange: onTriggerVisibleChange,
      trigger: "click",
      children: /*#__PURE__*/_jsx(StyledPlusButton, {
        type: "button",
        id: "add-plus-button",
        $active: true,
        "aria-label": labelTranslation.addContent,
        "aria-expanded": visible,
        children: /*#__PURE__*/_jsx(PlusIcon, {})
      })
    }) :
    /*#__PURE__*/
    // Click (not hover) so the warning does not auto-open when the mouse is
    // still over the + button right after creating a question.
    _jsx(StyledPlusButton, {
      type: "button",
      $active: false,
      onClick: handleBlockedCreateClick,
      "aria-label": labelTranslation.addContent,
      children: /*#__PURE__*/_jsx(PlusIcon, {})
    })
  });
};